import React from 'react';
import { SubscribePanel } from './view/subscribePanel';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'SubscribePanel',
  itemElt: (item, cmsOption) => <SubscribePanel item={item} cmsOption={cmsOption} />,
};
